<div class="broker-details-selection-container" *ngIf="brokerSettingsModel">

    <div class="margin-hr">
        <h3 class="text-accent dialog-title">Fill Broker Details</h3>
        <div class="divider bg-accent chamfer"></div>
    </div>

    <div class="broker-form">

        <mat-form-field class="broker-setting-field condensed-select-field margin-hr margin-8-vr" appearance="outline" color="accent">
            <mat-label>Broker</mat-label>

            <mat-select [formControl]="brokerFormCtrl">
                <mat-option *ngFor="let choice of brokerSettingsModel.brokerKeys | keyvalue" [value]="choice.key">
                    {{ choice.key | sentence }}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field class="broker-setting-field condensed-select-field margin-hr margin-8-vr" appearance="outline"
            color="accent" *ngFor="let field of formArray">
            <mat-label>
                {{ field.field.name | sentence }}
                <ng-container *ngIf="field.field.isOptional">(Optional)</ng-container>
            </mat-label>

            <input matInput [formControl]="field.control"
                [type]="field.field.isPassword && showPassword ? 'password': 'text'">
            <mat-icon *ngIf="field.field.isPassword" matSuffix [svgIcon]="showPassword ? 'eye_off' : 'eye'" 
                class="margin-8-top" (click) = "showPassword = !showPassword"></mat-icon>
            <mat-error *ngIf="field.control.hasError('required')">
                {{ field.field.name | sentence }} is required
            </mat-error>
        </mat-form-field>
    </div>

    <div class="action-button text-right">
        <button class="margin" mat-raised-button color="warn" mat-dialog-close>Cancel</button>
        <button class="margin" mat-raised-button color="accent" (click)="checkForUsernamechange()">
            Save
        </button>
    </div>
</div>
